<script>
  // core components
  import CardStats from "components/Cards/CardStats.svelte";
  import { onMount } from "svelte";
  import { gostergeList, degerList, formulList, boyutList} from "../../Api.svelte"

  let g_l= [];
  let d_l= [];
  let f_l= [];
  let b_l= [];

  onMount(async () => {
    g_l = await gostergeList();
    d_l = await degerList();
    f_l = await formulList();
    b_l = await boyutList();
  });

</script>

<!-- Header -->
<div class="relative bg-red-500 md:pt-32 pb-32 pt-12">
  <div class="px-4 md:px-10 mx-auto w-full">
    <div>
      <!-- Card stats -->
      <div class="flex flex-wrap">
        <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
          <CardStats
            statSubtitle="Boyut Sayısı"
            statTitle="{b_l.length}"
            statArrow="up"        
            statPercentColor="text-emerald-500"
            statDescripiron="Girilen Boyut Adedi"
            statIconName="far fa-chart-bar"
            statIconColor="bg-emerald-500"
          />
        </div>
        <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
          <CardStats
            statSubtitle="Gösterge Sayısı"
            statTitle="{g_l.length}"
            statArrow="up"        
            statPercentColor="text-emerald-500"
            statDescripiron="Girilen Gosterge Adedi"
            statIconName="far fa-chart-bar"
            statIconColor="bg-red-500"
          />
        </div>
        <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
          <CardStats
            statSubtitle="Formül Sayısı"
            statTitle="{f_l.length}"
            statArrow="up"
            statPercentColor="text-red-500"
            statDescripiron="Girilen Formül Sayısı"
            statIconName="fa fa-calculator"
            statIconColor="bg-orange-500"
          />
        </div>
        <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
          <CardStats
            statSubtitle="Deger Sayısı"
            statTitle="{d_l.length}"
            statArrow="up"
            statPercentColor="text-orange-500"
            statDescripiron="Girilen Değer Saysı"
            statIconName="fa fa-cog"
            statIconColor="bg-pink-500"
          />
        </div>

      </div>
    </div>
  </div>
</div>
